export default {
  validate_amount_number: 'Amount must be a number, greater than 0',
  valid_email_or_id: 'Here must be a valid email or account id',
  valid_secret_key: 'Here must be a valid secret key',
  valid_account_id: 'Here must be a valid account id',
  valid_password_az: 'Password must have a-z, A-Z and 0-9',
  invalid_phone_number: 'Invalid phone number',
  invalid_wallet_address: 'Invalid wallet address',
  accountRestrictedGoToKyc: 'Your account functionality is restricted. To get advanced functionality go to',
  auth_copyright: ' © DIT.',
  disposable_mail_error: 'Email is not from allowed domain',
  invalid_email_error: 'Email is invalid in some way',
  expired_signature: `Expired signature error. Please check if the time on your device is correct and try again`,
  not_found: 'Wrong email or password',
  email_not_verified_on_recovery: 'It is not possible to recover account with unverified email',
  email_verified: 'Email successfully verified',
  email_not_verified: 'Email not verified. Please check your mailbox',
  email_sent: 'Request successfully sent. Please check your inbox',
  password_not_verified: 'Wrong password',
  password_do_not_match: 'Passwords do not match',
  password_change_failed: 'Failed to change password. Try again later',
  password_changed: 'Password successfully changed',
  recovery_wallet_not_found: 'Wrong email or recovery seed',
  role_mail_error: 'Role emails are not allowed',
  recovered: 'Account successfully recovered. You can now login with new credentials',
  tfa_wrong_code: 'Wrong code',
  tfa_to_many_attempts: 'The account is blocked. Too many wrong TFA attempts. Contact an administrator',
  user_exists: 'User with such email already exists',
  wrong_password: 'Wrong Password',
  tfa_disabled: '2-Factor authentication successfully disabled',
  tfa_recovery: '2-Factor authentication lost. 2-Factor authentication can be restored in settings',
  tfa_recovery_blocked: '2-Factor authentication lost. Account blocked',
  tfa_recovery_unblocked: '2-Factor authentication successfully reseted',
  auth_and: 'and',
  recovery_title: 'Account recovery',
  recovery_description: 'Know your credentials?'
}



// WEBPACK FOOTER //
// ./src/js/i18n/views/auth_view.js